import { renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3073db59")

_pushScopeId("data-v-3073db59")
const _hoisted_1 = { class: "jumbotron" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "header"
}
const _hoisted_5 = {
  key: 1,
  class: "main"
}
const _hoisted_6 = { class: "side" }
const _hoisted_7 = { class: "footer" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("article", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        (_ctx.$slots.header)
          ? (_openBlock(), _createBlock("h2", _hoisted_4, [
              _renderSlot(_ctx.$slots, "header", {}, undefined, true)
            ]))
          : _createCommentVNode("", true),
        (_ctx.$slots.main)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _renderSlot(_ctx.$slots, "main", {}, undefined, true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
        ])
      ])
    ]),
    (_ctx.$slots.image)
      ? _renderSlot(_ctx.$slots, "image", { key: 0 }, undefined, true)
      : _createCommentVNode("", true)
  ]))
})